module.exports = __webpack_public_path__ + "media/images/application/template/map-cluster-markers/m1-617ebc135098e73b561c292ae48c4493.png";